import script from "./NewsMalaysia.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsMalaysia.vue?vue&type=script&setup=true&lang=js"

import "./NewsMalaysia.vue?vue&type=style&index=0&id=701f5c9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701f5c9f"]])

export default __exports__